module.exports = __webpack_public_path__ + "img/thai-style-monkfish-mushroom-kebabs.7776e940.jpg";